import { render } from "./aboutImg.vue?vue&type=template&id=0a293100&scoped=true"
import script from "./aboutImg.vue?vue&type=script&lang=js"
export * from "./aboutImg.vue?vue&type=script&lang=js"

import "./aboutImg.vue?vue&type=style&index=0&id=0a293100&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a293100"]])

export default __exports__